import React, { FC, ReactElement } from 'react';
import { createStyles, makeStyles, withStyles } from '@mui/styles';
// Components
import PinPanelComponent from './pinPanelComponent';
// Resources
import { PinProps } from './mapTypes';
import SvgIcon from '../icons/SvgIcon';
import { IconAxel, IconCommon } from '../../resources/images';
import { useEvent } from '../../hooks/useEvent';
import { EventType } from '../../core/apiTypes';
// Style
import styles from './pin-style';

const CarPinComponent: FC<PinProps> = ({ lat, lng, classes, drawed, heading, ...rest }): ReactElement => {
    const customClasses = useStyles({ heading });

    // Wicked
    const { currentEvent } = useEvent();
    const isWicked = currentEvent === EventType.WICKED;

    return (
        <div id="car" className={customClasses.carRotation}>
            <SvgIcon
                icon={isWicked ? IconAxel.MapCarWickedIcon : IconCommon.MapCarIcon}
                stroke="none"
                className={classes.pinPos}
                size="inherit"
            />
            <PinPanelComponent mode="from" {...rest} classes={classes} drawed={drawed} />
        </div>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        carRotation: (props: { heading: number | null }) => ({
            ...(props.heading != null && {
                transform: `rotate(${(props.heading - 7 + 90) % 360}deg)`, // We remove -7° cause the car icon design is already rotated + 90 to face North as heading 0° is facing north
                transformOrigin: 'top', // Rotate around the center top point
            }),
        }),
    }),
);

export default withStyles(styles)(CarPinComponent);
